import React from 'react';
import styled from "styled-components";
import BreadcrumbsSeparator from "./BreadcrumbsSeparator";
import Crumb from "./Crumb";
const Breadcrumbs = props => {
    const crumbsWithSpacers = [];
    props.breadcrumbs.map((breadcrumb, index) => {
        if (index < props.breadcrumbs.length - 1) {
            crumbsWithSpacers.push(React.createElement(Crumb, { isActive: false, displayName: breadcrumb.displayName, key: breadcrumb.displayName, url: breadcrumb.url }));
            crumbsWithSpacers.push(React.createElement(BreadcrumbsSeparator, { key: `breadcrumb_separator_${index}` }));
        }
        else {
            crumbsWithSpacers.push(React.createElement(Crumb, { isActive: true, displayName: breadcrumb.displayName, key: breadcrumb.displayName, url: breadcrumb.url }));
        }
    });
    return (React.createElement(BreadcrumbsWrapper, null,
        React.createElement("div", null, crumbsWithSpacers),
        props.children));
};
const BreadcrumbsWrapper = styled.nav `
  display: flex;
  align-items: center;
  justify-content: space-between;

  z-index: 10;

  height: 48px;

  padding-left: 16px;
  
  background-color: #ffffff;
  opacity: 1;

  border-bottom: 1px solid ${props => props.theme.colors.borderGrayLight};
`;
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map